import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-vorlage-anlegen-admin';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlageAnlegenAdminEffects {

    IncidentVorlageAnlegenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN),
        mergeMap((x: ac.PostIncidentVorlageAnlegenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentVorlageAnlegenAdmin(x.incidentVorlageDatenRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentVorlageAnlegenAdminErfolgreichAction(result, x.incidentVorlageDatenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentVorlageAnlegenAdminFehlerAction(error, x.incidentVorlageDatenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentVorlageCommandService);
        }
        return this.service;
    }
}
